import * as React from 'react'
import Button from '../Button'

const Step = ({
  data,
  setCurrentStep,
  setIsLastStep,
  activeDot,
  setActiveDot,
  loadingStepValues,
  setLoadingStepValues,
  stepValues,
  setStepValues,
}) => {
  const goToStep = (e, next, key, loading, link) => {
    if (typeof link !== 'undefined') window.location = link

    const { value } = e.currentTarget

    setStepValues({ ...stepValues, [key]: value })
    setLoadingStepValues({ ...loadingStepValues, [value]: { ...loading } })

    // Used to increment the dot navigation
    setActiveDot(activeDot + 1)

    // Go to the next step that's defined in `StepsData.jsx` for the current step or else set isLastStep to true
    if (next === null) {
      setIsLastStep(true)
    } else {
      setCurrentStep(next)
    }
  }

  return data.map(({ icon, text, key, value, link, next, loading }) => (
    <div className="step-button-wrapper">
      <Button
        className="leshen-mega-form-step-button"
        key={`${key}_${text}`}
        onClick={(e) => goToStep(e, next, key, loading, link)}
        variant="mega"
        value={value}
        leftIcon={icon}
      >
        {text}
      </Button>
    </div>
  ))
}

export default Step
